// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const FastForward = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 96 96" {...props}>
		<path
			d="M47.842 46.179V20.078c0-3.962 2.508-5.154 5.577-2.643l31.78 26.001c3.068 2.511 3.068 6.62 0 9.129l-31.78 26c-3.066 2.51-5.577 1.32-5.577-2.645V49.824c-.358 1.005-1.019 1.952-1.983 2.74L14.08 78.567C11.011 81.074 8.5 79.885 8.5 75.92V20.078c0-3.962 2.511-5.154 5.58-2.643l31.78 26.001c.963.79 1.624 1.737 1.982 2.743Z"
			fillRule="evenodd"
		/>
	</svg>
);
export default FastForward;
